import { z } from 'zod';
import { PIN_PATTERN } from '@/features/administrators/utils';

export const pinFields = {
  pin: z.string().regex(PIN_PATTERN, 'Exactly 6 digits'),
  pin_confirmation: z.string(),
};

export const mobilePinSchema = z
  .object({ ...pinFields, current_password: z.string().min(1, 'Enter your console password') })
  .refine((values) => values.pin === values.pin_confirmation, {
    message: 'The PINs don’t match',
    path: ['pin_confirmation'],
  });

export type IMobilePinForm = z.infer<typeof mobilePinSchema>;
